import { SLOTS_APIS } from "@/api_framework/api_config";

import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import { IBookingMembershipListResponse } from "@/api_framework/api_modals/Bookings";
import { setMembershipData } from "@/app_redux/reducers/slices/auth/slots_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useBookingMembershipListAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(SLOTS_APIS?.MEMBERSHIP_LIST?.baseURL ?? "", {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IBookingMembershipListResponse>) => {
          if (res.data.status === true) {
            //
            dispatch(
              setMembershipData({
                data: res.data.data,
              }),
            );
          } else {
            // Else Block
          }
        })
        .catch((e: AxiosError) => {
          // captureError(e);
          sendCurl(e.config["curlCommand"]);
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
